const LogoIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="85"
      height="20"
      viewBox="0 0 85 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.46657 3.01848L0 19.6747H5.5327C7.06779 19.6747 8.41128 18.6431 8.80761 17.16L13.3898 0.0136719L12.1064 0.0136777C10.1029 0.0136867 8.28613 1.19023 7.46657 3.01848Z"
        fill="#B3C1F7"
      />
      <path
        d="M30.9789 20C28.1759 20 25.9844 19.2228 24.4042 17.6685C22.824 16.1142 22.0339 13.8951 22.0339 11.0112V0H26.6051V10.8427C26.6051 12.7154 26.9908 14.0637 27.7621 14.8876C28.5334 15.7116 29.615 16.1236 31.0071 16.1236C32.3992 16.1236 33.4808 15.7116 34.2521 14.8876C35.0234 14.0637 35.409 12.7154 35.409 10.8427V0H39.9239V11.0112C39.9239 13.8951 39.1338 16.1142 37.5536 17.6685C35.9734 19.2228 33.7818 20 30.9789 20Z"
        fill="#03152F"
      />
      <path
        d="M42.7119 19.6629V0H51.1489C53.8954 0 56.0306 0.636704 57.5543 1.91011C59.0781 3.16479 59.84 4.90637 59.84 7.13483C59.84 8.59551 59.4919 9.85955 58.7959 10.927C58.0999 11.9757 57.1122 12.7809 55.833 13.3427C54.5539 13.9045 53.0301 14.1854 51.2618 14.1854H45.2514L47.2831 12.191V19.6629H42.7119ZM55.2687 19.6629L50.3306 12.5281H55.2123L60.2068 19.6629H55.2687ZM47.2831 12.6966L45.2514 10.5618H51.0078C52.4187 10.5618 53.4722 10.2622 54.1682 9.66292C54.8642 9.04494 55.2123 8.20225 55.2123 7.13483C55.2123 6.04869 54.8642 5.20599 54.1682 4.60674C53.4722 4.00749 52.4187 3.70787 51.0078 3.70787H45.2514L47.2831 1.54494V12.6966Z"
        fill="#03152F"
      />
      <path
        d="M62.5949 19.6629L71.3988 0H75.9137L84.7458 19.6629H79.9488L72.7251 2.30337H74.531L67.2791 19.6629H62.5949ZM66.9969 15.4494L68.2102 11.9944H78.3686L79.6102 15.4494H66.9969Z"
        fill="#03152F"
      />
      <path
        d="M17.3538 19.663H22.1508L17.7348 9.83154L13.0508 15.4495H15.5565L17.3538 19.663Z"
        fill="#03152F"
      />
      <path
        d="M15.4237 4.60059L12.6344 4.60059C11.5467 4.60059 10.5251 5.12251 9.88768 6.00383L0 19.6748L6.00928 19.6748C7.30951 19.6748 8.49517 18.9311 9.06113 17.7605L15.4237 4.60059Z"
        fill="#7B92F1"
      />
      <path
        d="M17.3729 8.82715H13.4673C12.6358 8.82715 11.8333 9.13276 11.2125 9.68587L0 19.6746H6.56986C7.56326 19.6746 8.50666 19.2389 9.15072 18.4825L17.3729 8.82715Z"
        fill="#1068EB"
      />
    </svg>
  );
};

export default LogoIcon;
